import React from "react";
import {connect} from 'dva';
import {Descriptions} from 'antd';
import {framework_tool, component_tool, utils_tool} from '@/tool'
import createColumns from './columns'

let {WizContainer, modelUtils} = framework_tool
let {WizCard, WizSpin, WizButton, WizSearchBar, WizDataTable, WizBrowserExport, WizTabs,} = component_tool
let {Session, getPageData} = utils_tool


const getDetailRecord = (history) => {
  let pathname = history.location.pathname;

  let detailInfo = ''
  const sessionName = pathname.split('/').filter(item => !!item).join('-') + '-Record'
  if (history?.location?.record) {
    detailInfo = history.location.record || {}
    Session.add(sessionName, detailInfo)
  } else {
    detailInfo = Session.get(sessionName) || {}
  }
  return detailInfo
}

class ContentRecord extends WizContainer {
  componentName = 'contentRecord'

  constructor(props) {
    super(props)
    const {history} = props

    let detailInfo = getDetailRecord(props.history);
    this.detailInfo = detailInfo
    this.visitFilters = {}
    this.chooseFilters = {}
    this.state = {
      contentId: detailInfo.id,
      operationType: 1,
      favoritesCount: 0,
      likeCount: 0,
      readCount: 0,
      downloadCount: 0
    }
    this.bizType = 20;

    if ('/content/learningMaterialsManage/record' === history?.location?.pathname) {
      this.hiddenType = 'learningMaterials';
    } else {
      this.hiddenType = 'content';
    }
  }

  _componentDidMount() {
    this._getFavoritesList();
    this._getLikeList()
    this._getReadList();
    this._getDownloadList();
  }

  propsAndStateOnChange = {
    favoritesPageList: this._favoritesList.bind(this),
    favoritesExport: this._favoritesExportOver.bind(this),
    likeExport: this._likeExportOver.bind(this),
    likePageList: this._likePageList.bind(this),
    recordExport: this._exportOver.bind(this),
    readPageList: this._readPageList.bind(this),
    downloadPageList: this._downloadPageList.bind(this),
    readLearningMaterialRecordExport: this._readLearningMaterialRecordExport.bind(this),
    downloadLearningMaterialRecordExport: this._downloadLearningMaterialRecordExport.bind(this),
    favoriteLearningMaterialRecordExport: this._favoriteLearningMaterialRecordExport.bind(this),
    likeLearningMaterialRecordExport: this._likeLearningMaterialRecordExport.bind(this),
  }


  /**
   * record download count
   * @param {*} nextProps
   * @param {*} nextState
   */
  _downloadPageList(nextProps, nextState) {
    let {downloadPageList} = nextProps
    if (downloadPageList['success']) {
      if (downloadPageList['data'] && downloadPageList['data']['total']) {
        nextState['downloadCount'] = downloadPageList['data']['total']
      }
    }
    return true
  }


  /**
   * record read count
   * @param {*} nextProps
   * @param {*} nextState
   */
  _readPageList(nextProps, nextState) {
    let {readPageList} = nextProps
    log.info('readPageList:', readPageList)
    if (readPageList['success']) {
      if (readPageList['data'] && readPageList['data']['total']) {
        nextState['readCount'] = readPageList['data']['total']
      }
    }
    return true
  }

  /**导出记录*/
  _exportOver(nextProps, nextState) {
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
        }
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '任职',
        field: 'userIdentityInfos',
        width: 40,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: `${nextState['operationType'] ? '阅读时间' : '下载时间'}`,
        field: 'operationTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      nextState['operationType'] ? null : {
        headerName: `文件名`,
        field: 'fileName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
    ].filter(item => !!item)
    if (nextProps.recordExport.code === 1) {
      let data = nextProps.recordExport.data
      WizBrowserExport({
        title: `${nextState['operationType'] ? '阅读' : '下载'}记录信息`,
        sheetName: `${nextState['operationType'] ? '阅读' : '下载'}记录信息`,
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: `${nextState['operationType'] ? '阅读' : '下载'}记录信息.xlsx`,
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }
  /**按任职导出阅读记录*/
  _readLearningMaterialRecordExport(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
        }
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '组织名称',
        field: 'orgPathName',
        width: 40,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '组织编码',
        field: 'orgCode',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '岗位名称',
        field: 'positionName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '首次阅读时间',
        field: 'firstOperationTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
    ]
    let data = nextProps.readLearningMaterialRecordExport.data
      WizBrowserExport({
        title: '阅读记录信息',
        sheetName: '阅读记录信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '阅读记录信息.xlsx',
      })
      return true;

  }

  _downloadLearningMaterialRecordExport(nextProps, nextState, key = 'downloadLearningMaterialRecordExport') {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
        }
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '组织名称',
        field: 'orgPathName',
        width: 40,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '组织编码',
        field: 'orgCode',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '岗位名称',
        field: 'positionName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '首次下载时间',
        field: 'firstOperationTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
    ]
    let data = o?.data || []
    WizBrowserExport({
      title: '下载记录信息',
      sheetName: '下载记录信息',
      columns: columnDefs.filter((_, index) => index),
      rows: data,
      filename: '下载记录信息.xlsx',
    })
    return true;

  }

  /**按任职导出收藏记录*/
  _favoriteLearningMaterialRecordExport(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
        }
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '组织名称',
        field: 'orgPathName',
        width: 40,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '组织编码',
        field: 'orgCode',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '岗位名称',
        field: 'positionName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '首次收藏时间',
        field: 'firstOperationTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
    ]
    let data = nextProps.favoriteLearningMaterialRecordExport.data
      WizBrowserExport({
        title: '收藏记录信息',
        sheetName: '收藏记录信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '收藏记录信息.xlsx',
      })
      return true;

  }

  /**按任职导出点赞记录*/
  _likeLearningMaterialRecordExport(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
        }
      },
      {
        headerName: '账号',
        field: 'userName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '姓名',
        field: 'fullName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '组织名称',
        field: 'orgPathName',
        width: 40,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '组织编码',
        field: 'orgCode',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '岗位名称',
        field: 'positionName',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
      {
        headerName: '首次点赞时间',
        field: 'firstOperationTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: {vertical: 'bottom', horizontal: 'left'},
        },
      },
    ]
    let data = nextProps.likeLearningMaterialRecordExport.data
      WizBrowserExport({
        title: '点赞记录信息',
        sheetName: '点赞记录信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '点赞记录信息.xlsx',
      })
      return true;

  }

  _favoritesExportOver(nextProps, nextState) {
    let {success, data} = nextProps.favoritesExport
    if (success) {
      let columnDefs = [
        {
          headerName: '',
          width: 30,
          field: 'rowIndex',
          hidden: true,
          suppressMovable: true,
          cellStyle: {
            textAlign: 'center',
            padding: '5px 0',
            color: '#595959',
            backgroundColor: '#f0f0f0',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: '500',
            boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
          }
        },
        {
          headerName: '账号',
          field: 'userName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '姓名',
          field: 'fullName',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '任职',
          field: 'identityInfos',
          width: 40,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
        {
          headerName: '收藏时间',
          field: 'favoritesTime',
          width: 20,
          cellStyle: {
            textAlign: 'center',
          },
          style: {
            alignment: {vertical: 'bottom', horizontal: 'left'},
          },
        },
      ]
      const getIdentityInfo = (identity) => identity && Object.keys(identity).length ? `${identity.orgName} - ${identity.positionName}` : ''

      data.forEach((val, index) => {
        val['identityInfos'] = val['identityList']?.map(item => getIdentityInfo(item)).join(',')
      })

      WizBrowserExport({
        title: `收藏记录信息`,
        sheetName: `收藏记录信息`,
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: `收藏记录信息.xlsx`,
      })
      return true;
    } else {
      wizNotice.error('获取导出数据失败')
      return false;
    }
  }
  _likeExportOver(nextProps, nextState) {
      let {success, data} = nextProps.likeExport
      if (success) {
        let columnDefs = [
          {
            headerName: '',
            width: 30,
            field: 'rowIndex',
            hidden: true,
            suppressMovable: true,
            cellStyle: {
              textAlign: 'center',
              padding: '5px 0',
              color: '#595959',
              backgroundColor: '#f0f0f0',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: '500',
              boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)'
            }
          },
          {
            headerName: '账号',
            field: 'userName',
            width: 20,
            cellStyle: {
              textAlign: 'center',
            },
            style: {
              alignment: {vertical: 'bottom', horizontal: 'left'},
            },
          },
          {
            headerName: '姓名',
            field: 'fullName',
            width: 20,
            cellStyle: {
              textAlign: 'center',
            },
            style: {
              alignment: {vertical: 'bottom', horizontal: 'left'},
            },
          },
          {
            headerName: '任职',
            field: 'identityInfos',
            width: 40,
            cellStyle: {
              textAlign: 'center',
            },
            style: {
              alignment: {vertical: 'bottom', horizontal: 'left'},
            },
          },
          {
            headerName: '点赞时间',
            field: 'operateTime',
            width: 20,
            cellStyle: {
              textAlign: 'center',
            },
            style: {
              alignment: {vertical: 'bottom', horizontal: 'left'},
            },
          },
        ]
        const getIdentityInfo = (identity) => identity && Object.keys(identity).length ? `${identity.orgName} - ${identity.positionName}` : ''

        data.forEach((val, index) => {
          val['identityInfos'] = val['identityList']?.map(item => getIdentityInfo(item)).join(',')
        })

        WizBrowserExport({
          title: `点赞记录信息`,
          sheetName: `点赞记录信息`,
          columns: columnDefs.filter((_, index) => index),
          rows: data,
          filename: `点赞记录信息.xlsx`,
        })
        return true;
      } else {
        wizNotice.error('获取导出数据失败')
        return false;
      }
    }

  _getReadExportList(apiParams = {}) {
    let {contentId} = this.state
    this.doAction({
      path: 'contentRecord/learningMaterialRecordExport',
      payload: {
        key: 'contentRecord@readLearningMaterialRecordExport',
        apiParams: {
          contentId: contentId,
          operateType: 2,
        }
      }
    })
  }
  _getDownloadExportList(apiParams = {}) {
    let {contentId} = this.state
    this.doAction({
      path: 'contentRecord/learningMaterialRecordExport',
      payload: {
        key: 'contentRecord@downloadLearningMaterialRecordExport',
        apiParams: {
          contentId: contentId,
          operateType: 3,
        }
      }
    })
  }
  _getFavoriteExportList(apiParams = {}) {
    let {contentId} = this.state
    this.doAction({
      path: 'contentRecord/learningMaterialRecordExport',
      payload: {
        key: 'contentRecord@favoriteLearningMaterialRecordExport',
        apiParams: {
          contentId: contentId,
          operateType: 0,
        }
      }
    })
  }
  _getLikeExportList(apiParams = {}) {
    let {contentId} = this.state
    this.doAction({
      path: 'contentRecord/learningMaterialRecordExport',
      payload: {
        key: 'contentRecord@likeLearningMaterialRecordExport',
        apiParams: {
          contentId: contentId,
          operateType: 1,
        }
      }
    })
  }
  _getFavoritesList(apiParams = {}) {
    let {contentId} = this.state
    this.doAction({
      path: 'favorites/list',
      payload: {
        key: 'favorites@favoritesPageList',
        apiParams: {
          bizType: this.bizType,
          bizId: contentId,
          ...apiParams
        }
      }
    })
  }
  _getFavoritesInfo(apiParams = {}) {
    let {contentId} = this.state
    this.doAction({
      path: 'favorites/export',
      payload: {
        key: 'favorites@favoritesList',
        apiParams: {
          bizType: this.bizType,
          bizId: contentId,
          ...apiParams
        }
      }
    })
  }

  _favoritesList(nextProps, nextState) {
    let {favoritesPageList} = nextProps
    if (favoritesPageList['success']) {
      if (favoritesPageList['data'] && favoritesPageList['data']['total']) {
        nextState['favoritesCount'] = favoritesPageList['data']['total']
      }
    }
    return true
  }

  _getLikeList(apiParams = {}) {
    let {contentId} = this.state
    this.doAction({
      path: 'operateRecord/operateRecordUserPageList',
      payload: {
        key: 'operateRecord@likePageList',
        apiParams: {
          bizType: this.bizType,
          bizId: contentId,
          operateType: 1,
          ...apiParams
        }
      }
    })
  }

  _getLikeInfo(apiParams = {}) {
    let {contentId} = this.state
    this.doAction({
      path: 'operateRecord/operateRecordUserList',
      payload: {
        key: 'operateRecord@likeList',
        apiParams: {
          bizType: this.bizType,
          bizId: contentId,
          operateType: 1,
          ...apiParams
        }
      }
    })
  }

  _likePageList(nextProps, nextState) {
    let {likePageList} = nextProps
    if (likePageList['success']) {
      if (likePageList['data'] && likePageList['data']['total']) {
        nextState['likeCount'] = likePageList['data']['total']
      }
    }
    return true
  }

  _getReadList(apiParams = {}) {
    let {contentId} = this.state
    this.doAction({
      path: 'contentRecord/listByPage',
      payload: {
        key: 'contentRecord@readPageList',
        apiParams: {
          contentId: contentId,
          operationType: 1,
          ...apiParams
        }
      }
    })
    this.setState({
      operationType: 1
    })
  }

  _getReadInfo(apiParams = {}) {
    let {contentId} = this.state
    this.doAction({
      path: 'contentRecord/export',
      payload: {
        key: 'contentRecord@recordList',
        apiParams: {
          contentId: contentId,
          operationType: 1,
          ...apiParams
        }
      }
    })

    this.setState({
      operationType: 1
    })
  }

  _onSelect(keys, rows) {
    this.setState({
      keys,
      rows,
      selectedRows: keys.length
    })
  }

  _getDownloadList(apiParams = {}) {
    let {contentId} = this.state
    this.doAction({
      path: 'contentRecord/listByPage',
      payload: {
        key: 'contentRecord@downloadPageList',
        apiParams: {
          contentId: contentId,
          operationType: 0,
          ...apiParams
        }
      }
    })

    this.setState({
      operationType: 0
    })
  }

  _getDownloadInfo(apiParams = {}) {
    let {contentId} = this.state
    this.doAction({
      path: 'contentRecord/export',
      payload: {
        key: 'contentRecord@recordList',
        apiParams: {
          contentId: contentId,
          operationType: 0,
          ...apiParams
        }
      }
    })
  }

  /**
   * 渲染操作按钮 且 进行权限检查
   */
  _renderBtn = (type) => {
    let r = []
    let btns = new Map();
    btns.set('export',<>
      <WizButton title="导出"
                 type="export"
                 onClick={() => {
                   let action = {
                     favorites: () => this._getFavoritesInfo(this.favoritesFilters),
                     like: () => this._getLikeInfo(this.likeFilters),
                     read: () => this._getReadInfo(this.visitFilters),
                     download: () => this._getDownloadInfo(this.chooseFilters),
                   }
                   action?.[type]?.()
                 }}
                 icon="export"
                 style={{marginBottom: 15}}>导出</WizButton>
                 <WizButton title="按任职导出"
                 type="export"
                 onClick={() => {
                   let action = {
                     favorites: () => this._getFavoriteExportList(this.favoritesFilters),
                     like: () => this._getLikeExportList(this.likeFilters),
                     read: () => this._getReadExportList(this.visitFilters),
                     download: () => this._getDownloadExportList(this.chooseFilters),
                   }
                   action?.[type]?.()
                 }}
                 icon="export"
                 style={{marginBottom: 15,marginLeft:20}}
                 >按任职导出</WizButton></>

                 );
    let btnCode = this.getMenuBtn() || [];
    btnCode.map(({code}) => {
      if (btns.has(code)) {
        r.push(btns.get(code))
      }
    })
    return r
  }


  renderRecordInfo = (type) => {
    let {favoritesPageList, likePageList, readPageList, downloadPageList, loading} = this.props
    let columns = createColumns(this, type)
    let pageList = {
      favorites: favoritesPageList,
      like: likePageList,
      read: readPageList,
      download: downloadPageList,
    }[type];

    let list = getPageData(pageList && pageList.data)
    let searchBarProps = {
      columns,
      onSearch: values => {
        if (type === 'favorites') {
          this.favoritesFilters = values
          this._getFavoritesList(values)
        }
        if (type === 'like') {
          this.likeFilters = values
          this._getLikeList(values)
        }
        if (type === 'read') {
          this.visitFilters = values
          this._getReadList(values)
        }
        if (type === 'download') {
          this.chooseFilters = values
          this._getDownloadList(values)
        }
      }
    }
    let dataTableProps = {
      loading: loading,
      columns,
      rowKey: 'id',
      dataItems: list,
      isScroll: true,
      onChange: ({pageNum, pageSize}) => {
        let action = {
          favorites: () => this._getFavoritesList({current: pageNum, size: pageSize, ...this.favoritesFilters}),
          like: () => this._getLikeList({current: pageNum, size: pageSize, ...this.likeFilters}),
          read: () =>  this._getReadList({current: pageNum, size: pageSize, ...this.visitFilters}),
          download: () => this._getDownloadList({current: pageNum, size: pageSize, ...this.chooseFilters}),
        }

        action?.[type]?.()
      },
      onSelect: (keys, rows) => this._onSelect(keys, rows)
    }
    return (
      <WizSpin tip={'加载中'} spinning={loading}>
        <div className='pagination'>
          <WizSearchBar key="contentRecord_searchBar" type="grid" {...searchBarProps} />
        </div>
        {this._renderBtn(type)}
        <WizDataTable key={'contentRecord_dataTable'} {...dataTableProps} />
        <div className='pagination'>
          <WizDataTable.Pagination key={'contentRecord_pagination'} {...dataTableProps} />
        </div>
      </WizSpin>
    )
  }

  _render() {
    const items = this.detailInfo
    let {favoritesCount, likeCount, readCount, downloadCount} = this.state

    let recordTable = []

    if (this.hiddenType === 'learningMaterials') {
      recordTable.push({
        init: this._getFavoritesList.bind(this),
        view: <WizTabs.TabPane tab={`收藏记录(${favoritesCount})`} key={(recordTable.length + 1).toString()}>{this.renderRecordInfo('favorites')}</WizTabs.TabPane>,
      })
      recordTable.push({
        init: this._getLikeList.bind(this),
        view: <WizTabs.TabPane tab={`点赞记录(${likeCount})`} key={(recordTable.length + 1).toString()}>{this.renderRecordInfo('like')}</WizTabs.TabPane>,
      })
    }
    recordTable.push({
      init: this._getReadList.bind(this),
      view: <WizTabs.TabPane tab={`阅读记录(${readCount})`} key={(recordTable.length + 1).toString()}>{this.renderRecordInfo('read')}</WizTabs.TabPane>,
    })
    if (this.hiddenType === 'content') {
      recordTable.push({
        init: this._getDownloadList.bind(this),
        view: <WizTabs.TabPane tab={`下载记录(${downloadCount})`} key={(recordTable.length + 1).toString()}>{this.renderRecordInfo('download')}</WizTabs.TabPane>,
      })
    }

    return (
      <React.Fragment>
        <WizCard title={'基础信息'}>
          <Descriptions column={2} style={{paddingLeft: 25}}>
            <Descriptions.Item label='标题'>{items.title}</Descriptions.Item>
            <Descriptions.Item label='内容类型'>{items.categoryNames}</Descriptions.Item>
            <Descriptions.Item label='作者'>{items.author}</Descriptions.Item>
            <Descriptions.Item label='发布时间'>{items.releaseTime}</Descriptions.Item>
          </Descriptions>
        </WizCard>

        <WizCard title="记录管理">
          <WizTabs defaultActiveKey="1" onChange={(e) => recordTable[parseInt(e) - 1].init()}>
            {recordTable.map(({view}) => view)}
          </WizTabs>
        </WizCard>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  let {contentRecord, favorites, operateRecord} = state
  const favoritesPageList = modelUtils.getModelEntity(favorites, 'favorites@favoritesPageList');
  const favoritesList = modelUtils.getModelEntity(favorites, 'favorites@favoritesList');
  const likePageList = modelUtils.getModelEntity(operateRecord, 'operateRecord@likePageList');
  const likeList = modelUtils.getModelEntity(operateRecord, 'operateRecord@likeList');
  const readPageList = modelUtils.getModelEntity(contentRecord, 'contentRecord@readPageList');
  const downloadPageList = modelUtils.getModelEntity(contentRecord, 'contentRecord@downloadPageList');
  const recordExport = modelUtils.getModelEntity(contentRecord, 'contentRecord@recordList');
  const readLearningMaterialRecordExport = modelUtils.getModelEntity(contentRecord,'contentRecord@readLearningMaterialRecordExport');
  const downloadLearningMaterialRecordExport = modelUtils.getModelEntity(contentRecord, 'contentRecord@downloadLearningMaterialRecordExport');
  const favoriteLearningMaterialRecordExport = modelUtils.getModelEntity(contentRecord,'contentRecord@favoriteLearningMaterialRecordExport');
  const likeLearningMaterialRecordExport = modelUtils.getModelEntity(contentRecord,'contentRecord@likeLearningMaterialRecordExport');
  const {contentRecordLoading: contentLoad} = modelUtils.getLoadingState(state, 'contentRecord')
  const {favoritesLoading: favoritesLoad} = modelUtils.getLoadingState(state, 'favorites')
  const {operateRecordLoading: likeLoad} = modelUtils.getLoadingState(state, 'operateRecord')

  return {
    favoritesPageList,
    favoritesExport: favoritesList,
    likePageList,
    likeExport: likeList,
    readPageList,
    downloadPageList,
    recordExport,
    readLearningMaterialRecordExport,
    downloadLearningMaterialRecordExport,
    favoriteLearningMaterialRecordExport,
    likeLearningMaterialRecordExport,
    loading: contentLoad || favoritesLoad || likeLoad
  }
};

export default connect(mapStateToProps)(ContentRecord)
